export const FETCH_ERROR = "Đã có lỗi xảy ra, xin vui lòng thử lại!";
export const BOOKING_SUCCESS = "Đăng ký lớp học thành công!";
export const CANCEL_BOOKING_SUCCESS = "Hủy lớp học thành công!";
export const CHANGE_PASSWORD_SUCCESS = "Đổi mật khẩu thành công!";
export const UPDATE_PROFILE_SUCCESS = "Câp nhật thông tin thành công!";

export const RATING_SUCCESS = "Cảm ơn bạn đã để lại phản hồi!";
export const REQUEST_SUCCESS = "Cảm ơn bạn đã để lại ghi chú!";

export const MAX_200 = "Tối đa 200 ký tự!";
export const FILL_NOTES = "Xin hãy điền thông tin ghi chú!";
export const FILL_REASON = "Xin hãy điền lý do hủy lớp!";
export const FILL_RATING = "Xin hãy đánh giá cho giáo viên!";
export const FILL_FEEDBACK = "Xin hãy để lại lời nhắn cho giáo viên!";
export const FILL_ALL = "Xin hãy điền đầy đủ thông tin!";
export const FILL_PASSWORD = "Mật khẩu không được để trống!";
export const DIFFERENT_PASSWORD = "Mật khẩu mới phải khác mật khẩu cũ!";
export const INCORRECT_PASSWORD = "Mật khẩu cũ không chính xác";
export const CONFIRM_PASSWORD = "Xác nhận mật khẩu không đúng, xin hãy nhập lại";